module.exports = __webpack_public_path__ + "img/oval2.abfbf08f.svg";